import { render, staticRenderFns } from "./Customerservice.vue?vue&type=template&id=2054b888&scoped=true"
import script from "./Customerservice.vue?vue&type=script&lang=js"
export * from "./Customerservice.vue?vue&type=script&lang=js"
import style0 from "./Customerservice.vue?vue&type=style&index=0&id=2054b888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2054b888",
  null
  
)

export default component.exports